import React from 'react';
import './styles.css';
import CardHelper from '../../helpers';

function CardView(props) {
    const extraSpace = props.classNumberTop && props.classNumberTop.includes("numberTop-ten") ? true : false;
    return (
        <div className={'card card-top'}>
            <div className={'card-container'}>
                <div
                    className={
                        props.imageNumbersTop.imgSrc !== undefined
                            ? 'preview-container'
                            : 'preview-container-not-number'
                    }
                >
                    {props.imageNumbersTop.imgSrc !== undefined && (
                        <div className={props.classNumberTop}>
                            <img src={props.imageNumbersTop.imgSrc} alt="" />
                        </div>
                    )}
                        <div
                            className={
                                props.imageNumbersTop.imgSrc !== undefined
                                    ? 'container-card-cover'
                                    : 'container-card-cover-not-number'
                            }
                        >
                            <img src={props.cover} alt="" />
                        </div>
                    {CardHelper.createProgressBar(props.bookmark)}
                    {CardHelper.createBadge(props.badges, extraSpace)}
                </div>
            </div>
            {props.bookmark > 0 && (
                <div className="card-labels-container">{CardHelper.createTitle(props.title)}</div>
            )}
        </div>
    );
}

export default CardView;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardTop/index.js